// (function () {
//   const isMobile = window.matchMedia("(max-width: 767px)").matches;
//   if (!isMobile) return;

//   function getScroller(root) {
//     const rail = root.querySelector(".xo-product-dock__rail");
//     const track = root.querySelector(".xo-product-dock__icons");

//     // Pick the element that actually scrolls
//     if (rail && rail.scrollWidth > rail.clientWidth) return rail;
//     if (track && track.scrollWidth > track.clientWidth) return track;

//     // Fallback
//     return rail || track;
//   }

//   function centerActive(root, behavior = "smooth") {
//     const scroller = getScroller(root);
//     const active = root.querySelector(".dock-icon.is-active");
//     if (!scroller || !active) return;

//     // icon offset relative to the scroller content
//     const scrollerRect = scroller.getBoundingClientRect();
//     const activeRect = active.getBoundingClientRect();

//     // Current scrollLeft + delta between centers
//     const delta =
//       (activeRect.left + activeRect.width / 2) -
//       (scrollerRect.left + scrollerRect.width / 2);

//     const target = scroller.scrollLeft + delta;

//     scroller.scrollTo({
//       left: target,
//       behavior
//     });
//   }

//   function initOne(root) {
//     if (root.dataset.mobileCenterInit === "true") return;
//     root.dataset.mobileCenterInit = "true";

//     const scroller = getScroller(root);
//     if (!scroller) return;

//     // 1) Center on load (after layout)
//     requestAnimationFrame(() => centerActive(root, "auto"));

//     // 2) When user stops scrolling, center the active item
//     // let timer = null;
//     // scroller.addEventListener(
//     //   "scroll",
//     //   () => {
//     //     clearTimeout(timer);
//     //     timer = setTimeout(() => centerActive(root, "smooth"), 120);
//     //   },
//     //   { passive: true }
//     // );
// let timer = null;
// let userScrolling = false;

// scroller.addEventListener("touchstart", () => {
//   userScrolling = true;
// });

// scroller.addEventListener("touchend", () => {
//   setTimeout(() => { userScrolling = false; }, 150);
// });

// const mo = new MutationObserver(() => {
//   if (userScrolling) return; // user scroll kar raha hai, disturb mat karo
//   clearTimeout(timer);
//   timer = setTimeout(() => centerActive(root, "smooth"), 60);
// });

//     // 3) If active changes (your JS toggles .is-active), recenter
//     const mo = new MutationObserver(() => {
//       // Avoid fighting user while they drag
//       clearTimeout(timer);
//       timer = setTimeout(() => centerActive(root, "smooth"), 60);
//     });

//     mo.observe(root, {
//       subtree: true,
//       attributes: true,
//       attributeFilter: ["class"]
//     });

//     // 4) If user taps an icon, center it immediately
//     root.addEventListener("click", (e) => {
//       const icon = e.target.closest(".dock-icon");
//       if (!icon) return;
//       setTimeout(() => centerActive(root, "smooth"), 0);
//     });
//   }

//   function initAll() {
//     document.querySelectorAll(".xo-product-dock").forEach(initOne);
//   }

//   document.addEventListener("DOMContentLoaded", initAll);
//   document.addEventListener("shopify:section:load", initAll);
//   document.addEventListener("xo:section:load", initAll);
// })();



(function () {
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  if (!isMobile) return;

  function getScroller(root) {
    const rail = root.querySelector(".xo-product-dock__rail");
    const track = root.querySelector(".xo-product-dock__icons");

    if (rail && rail.scrollWidth > rail.clientWidth) return rail;
    if (track && track.scrollWidth > track.clientWidth) return track;

    return rail || track;
  }

  function centerActive(root, behavior = "smooth") {
    const scroller = getScroller(root);
    const active = root.querySelector(".dock-icon.is-active");
    if (!scroller || !active) return;

    const scrollerRect = scroller.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();

    const delta =
      (activeRect.left + activeRect.width / 2) -
      (scrollerRect.left + scrollerRect.width / 2);

    scroller.scrollTo({
      left: scroller.scrollLeft + delta,
      behavior
    });
  }

  function initOne(root) {
    if (root.dataset.mobileCenterInit === "true") return;
    root.dataset.mobileCenterInit = "true";

    const scroller = getScroller(root);
    if (!scroller) return;

    let timer = null;
    let userScrolling = false;

    // detect user drag
    scroller.addEventListener("touchstart", () => {
      userScrolling = true;
    });

    scroller.addEventListener("touchend", () => {
      setTimeout(() => { userScrolling = false; }, 150);
    });

    // 1) center active on first load
    requestAnimationFrame(() => centerActive(root, "auto"));

    // 2) when .is-active changes (but not during manual scroll)
    const observer = new MutationObserver(() => {
      if (userScrolling) return;
      clearTimeout(timer);
      timer = setTimeout(() => centerActive(root, "smooth"), 80);
    });

    observer.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    });

    // 3) when user taps an icon, make it active + center it
    root.addEventListener("click", (e) => {
      const icon = e.target.closest(".dock-icon");
      if (!icon) return;

      // optional: if your other JS doesn't set active, do it here
      root.querySelectorAll(".dock-icon.is-active")
          .forEach(el => el.classList.remove("is-active"));
      icon.classList.add("is-active");

      setTimeout(() => centerActive(root, "smooth"), 0);
    });
  }

  function initAll() {
    document.querySelectorAll(".xo-product-dock").forEach(initOne);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("xo:section:load", initAll);
})();
